module.exports = __webpack_public_path__ + "static/media/shape-2.f816e737.webp";